import React, { Component } from 'react'
import "../index.css";
import { Slide } from "react-awesome-reveal";
export default class Home extends Component {
    
  render() {
    if (this.props.sharedBasicInfo) {
        var profilepic = "images/" + this.props.sharedBasicInfo.image;
      }
    return (
        <section class="home" id="home">
      <div class="home-content">
      <Slide>
        <h3>Hello, I am</h3>
        <h1>Curtrick Walton</h1>
        <p>Welcome to my captivating portfolio, thoughtfully crafted to showcase my passion and creativity. I'm thrilled you're here, and I hope your stay is nothing short of delightful.</p>
      </Slide>
        <div class="social-media">
            <a href="https://github.com/CurtWal "><i class='bx bxl-github' ></i></a>
            <a href="https://www.linkedin.com/in/curtrick-walton-553b4925a"><i class='bx bxl-linkedin' ></i></a>
            <a href="http://curtrickw@yahoo.com"><i class='bx bxl-yahoo' ></i></a>
        </div>

        <a href='https://drive.google.com/file/d/15IbQtpT3s5I2CL6SuYJL3efxKQh2ypgY/view?usp=sharing' class="btn">View Resume</a>
       
      </div>

      <div class="profession-container">
        <div class="profession-box">
            
            <div class="profession" style={{"--i":0}}>
            <i class='bx bx-code-alt' ></i>
            <h3>Web Developer</h3>
            </div>
            <div class="profession" style={{"--i":1}}>
            <i class='bx bx-code-alt' ></i>
            <h3>Frontend Developer</h3>
            </div>
            <div class="profession" style={{"--i":2}}>
            <i class='bx bx-code-alt' ></i>
            <h3>FullStack Developer</h3>
            </div>
            <div class="profession" style={{"--i":3}}>
            <i class='bx bx-code-alt' ></i>
            <h3>Backend Developer</h3>
            </div>

            <div class="circle"></div>
            </div>

            <div class="overlay"></div>
        </div>

           <div class="home-img">
            <img src={profilepic} alt="me"></img>
            </div> 
            
      </section>
    )
  }
}
